import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { SharedFeaturesService } from "./shared-features.service";
import { UserStateService } from "./user-state.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    private snackBar: SharedFeaturesService,
    private userStateService: UserStateService
  ) {
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const isLogoutRequest = req.url.includes('logout');

        if (error.status === 401) {
          // Clear cached user state so sign-in page doesn't redirect back to home
          // (prevents flickering loop when session invalidated e.g. login from another browser)
          this.userStateService.clearUserInfo();

          // For logout: user may already be logged out, show "Logged out" instead
          if (isLogoutRequest) {
            this.snackBar.openSnackBar('Logged out successfully.', 'Close', 'success-snackbar');
          } else {
            this.snackBar.openSnackBar(
              'Your session has expired. Please log in again.',
              'Close',
              'error-snackbar'
            );
          }
          this.router.navigate(['/account'], {
            queryParams: { returnUrl: this.router.routerState.snapshot.url },
          });
        }
        return throwError(() => error);
      })
    );
  }
}
